module.exports = __webpack_public_path__ + "81904d3804b7a21fa8f16e46664b55bb.svg";